import { createRouter, createWebHistory } from "@ionic/vue-router";
import type { RouteRecordRaw } from "vue-router";
import HomePage from "../views/HomePage.vue";
import TabsPage from "../views/TabsPage.vue";
import LoginPage from "../views/LoginPage.vue";
import { getBaseUrl } from "@/data/constants";
import { isTokenExpired } from "@/helper/jwt";

const routes: Array<RouteRecordRaw> = [
  {
    path: "/login",
    name: "Login",
    component: LoginPage,
  },
  {
    path: "/",
    name: "Root",
    redirect: "/tabs/",
  },
  {
    path: "/tabs/",
    component: TabsPage,
    children: [
      {
        path: "",
        redirect: "/tabs/tree/",
      },
      {
        path: "/tabs/tree/:id?",
        component: () => import("@/views/tabs/TabPageContainerTree.vue"),
        // beforeEnter: (to, from) => {
        //   // reject the navigation
        //   return false
        // },
      },
      {
        path: "list_all",
        component: () => import("@/views/tabs/TabPageListAll.vue"),
      },
      {
        path: "scan",
        component: () => import("@/views/tabs/TabPageScan.vue"),
      },
      {
        path: "settings",
        component: () => import("@/views/tabs/TabPageSettings.vue"),
      },
      {
        path: "settings/drafts",
        component: () => import("@/views/DraftsView.vue"),
      },
      {
        path: "schemas",
        component: () => import("@/views/SchemasView.vue"),
      },
    ],
  },
  {
    path: "/home",
    name: "Home",
    component: HomePage,
  },
  {
    path: "/item/:id/detail",
    component: () => import("../views/ItemDetailsView.vue"),
  },
  {
    path: "/item/:id/label",
    component: () => import("../views/PrintLabel.vue"),
  },
  {
    path: "/test/label",
    component: () => import("../libs/vue3-textfill/source/TesterPage.vue"),
  },
  {
    path: "/test/sentry",
    component: () => import("@/views/test/SentrySampleErrorView.vue"),
  },
];

if (import.meta.env.MODE !== "production") {
  routes.push({
    path: "/test/openapi-form",
    component: () => import("@/views/test/OpenApiFormTestView.vue"),
  });
}

const router = createRouter({
  history: createWebHistory(getBaseUrl(false)),
  routes,
});

router.beforeEach(async (to, from) => {
  const token = localStorage.getItem("accessToken");
  // An expired token would only fail on the first API call, so drop it here and ask for a login instead.
  if (token !== null && isTokenExpired(token)) {
    console.log("Stored access token is expired, dropping it.");
    localStorage.removeItem("accessToken");
    localStorage.removeItem("imagesToken");
  }
  const hasApiKey = localStorage.getItem("accessToken") !== null;
  console.log(
    `Checking login for route ${String(to.name)} (${
      to.fullPath
    }), coming from route ${String(from.name)} (${
      from.fullPath
    }), authenticated: ${hasApiKey}`
  );
  if (
    // Avoid an infinite redirect and check that we have a token
    to.name !== "Login" &&
    !hasApiKey
  ) {
    // redirect the user to the login page
    return { name: "Login" };
  }
});

export default router;
